import React from 'react';
import { Helmet } from 'react-helmet';
import { ChakraProvider, Box } from '@chakra-ui/react';
import { legacyTheme } from '../themes/legacyTheme';
import SEO, { MetadataItem } from './Seo';
import Navbar from './Navbar';
import Footer from './Footer';
import HoverCookieConsent from './shared/HoverCookieConsent';

export interface LayoutProps {
  title?: string;
  description?: string;
  isNavInitiallyWhite?: boolean;
  isNavInitiallyTransparent?: boolean;
  additionalMetadata?: MetadataItem[];
  noIndex?: boolean;
  children: React.ReactNode;
}

const Layout = ({
  title = '',
  description = '',
  noIndex = false,
  isNavInitiallyWhite = false,
  isNavInitiallyTransparent = true,
  additionalMetadata = [],
  children,
}: LayoutProps) => (
  <ChakraProvider theme={legacyTheme}>
    <Box w="100%">
      <Helmet>
        <script async src="https://awwtag.emaww.com/js?token=AWW-382978285-1" />
      </Helmet>
      <SEO
        title={title}
        description={description}
        additionalMetadata={additionalMetadata}
        noIndex={noIndex}
      />
      <Navbar
        isNavInitiallyWhite={isNavInitiallyWhite}
        isNavInitiallyTransparent={isNavInitiallyTransparent}
      />
      {children}
      <HoverCookieConsent />
      <Footer />
    </Box>
  </ChakraProvider>
);
Layout.defaultProps = {
  title: '',
  description: '',
  isNavInitiallyWhite: false,
  isNavInitiallyTransparent: true,
  additionalMetadata: [],
  noIndex: false,
};

export default Layout;
